import React, { useEffect } from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Benefits from '../components/Benefits';
import Biography from '../components/Biography';
import Activity from '../components/Activity';


const Portofolio = () => {
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    }, []);
    
    return (
        <>
            <Biography />
            <Activity />
            <Clients />
            <Benefits />
            <Footer />
        </>

    )
}

export default Portofolio;

